import { render } from "./ModalAssignPreparation.vue?vue&type=template&id=6ced9994"
import script from "./ModalAssignPreparation.vue?vue&type=script&lang=js"
export * from "./ModalAssignPreparation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__